import { render } from "./DepositWithdrawReport.vue?vue&type=template&id=6b592fb2&scoped=true"
import script from "./DepositWithdrawReport.vue?vue&type=script&lang=js"
export * from "./DepositWithdrawReport.vue?vue&type=script&lang=js"

import "./DepositWithdrawReport.vue?vue&type=style&index=0&id=6b592fb2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b592fb2"]])

export default __exports__